import { create } from "zustand";
import type { User, Organization } from "@cliently/types";

export type AppFeatures = {
  voiceReports: boolean;
  clientSynthesis: boolean;
};

interface AuthState {
  user: User | null;
  org: Organization | null;
  features: AppFeatures;
  setUser: (user: User | null) => void;
  setOrg: (org: Organization | null) => void;
  setFeatures: (features: AppFeatures) => void;
  reset: () => void;
}

const defaultFeatures: AppFeatures = {
  voiceReports: false,
  clientSynthesis: false,
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  org: null,
  features: defaultFeatures,
  setUser: (user) => set({ user }),
  setOrg: (org) => set({ org }),
  setFeatures: (features) => set({ features }),
  reset: () => set({ user: null, org: null, features: defaultFeatures }),
}));

export const useVoiceReportsFeature = () =>
  useAuthStore((s) => s.features.voiceReports);

export const useClientSynthesisFeature = () =>
  useAuthStore((s) => s.features.clientSynthesis);
